import {StoreKeys} from "./StoreKeys";

export function parsePreferences() {
    const params = new URLSearchParams(document.location.search);
    params.forEach((value, key) => {
        // Special handling for baseInitializationParams to remove Auth data from local storage
        if (key === StoreKeys.BASE_INITIALIZATION_PARAMS) {
            const baseInitializationParams = JSON.parse(value);
            // Store refresh token in session storage instead of localStorage
            try {
                sessionStorage.setItem(StoreKeys.REFRESH_TOKEN, baseInitializationParams.authPreferences.refreshToken);
            } catch (e) {
                console.error("Refresh Token missing", e)
            }
            // Remove Auth data
            delete baseInitializationParams["authPreferences"];
            // Stringify rest of data to be stored in local Storage
            value = JSON.stringify(baseInitializationParams);
        }
        // Save all info in local Storage
        localStorage.setItem(key, value);
    });
}

export function isVolumetricScanEnabled() {
    const moduleInitializationParams = JSON.parse(localStorage.getItem(StoreKeys.MODULE_INITIALIZATION_PARAMS));
    return moduleInitializationParams && moduleInitializationParams.volumetric_scan;
}


// WEBPACK FOOTER //
// ./src/components/utils/StorageUtil.js